var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "form",
      {
        on: {
          submit: function ($event) {
            $event.preventDefault()
            return _vm.onSubmit($event)
          },
        },
      },
      [
        _c(
          "div",
          { staticClass: "title-container", style: { background: "#dd3b5f" } },
          [
            _c("h2", { staticClass: "search-title" }, [
              _vm._v(
                _vm._s(_vm.searchboxheadlinerebooking[_vm.getCurrentLocale])
              ),
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                _vm._s(_vm.searchboxheadlineflights2[_vm.getCurrentLocale])
              ),
            ]),
            _vm._v(" "),
            _c("i", { staticClass: "soap-icon-search" }),
          ]
        ),
        _vm._v(" "),
        _c(
          "section",
          {
            staticStyle: { "padding-top": "20px", "background-color": "#fff" },
            attrs: { id: "content" },
          },
          [
            _c("div", { attrs: { id: "main" } }, [
              _c(
                "div",
                {
                  staticClass: "contact-address block",
                  staticStyle: {
                    "margin-left": "20px",
                    "margin-right": "20px",
                  },
                },
                [
                  _c("h4", [
                    _vm._v(_vm._s(_vm.hellotext1[_vm.getCurrentLocale])),
                  ]),
                  _vm._v(" "),
                  _c("br"),
                  _c("p", {
                    domProps: {
                      innerHTML: _vm._s(_vm.hellotext2[_vm.getCurrentLocale]),
                    },
                  }),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("hr"),
                  _vm._v(" "),
                  _c("h5", { staticClass: "title" }, [
                    _vm._v(_vm._s(_vm.when[_vm.getCurrentLocale])),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-xs-12" }, [
                      _c("label", [
                        _vm._v(
                          _vm._s(_vm.form_field1[_vm.getCurrentLocale]) + ":* "
                        ),
                        _c("small"),
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.input_invoiceid,
                            expression: "input_invoiceid",
                          },
                        ],
                        staticClass: "input-text full-width",
                        class: { invalid: _vm.$v.input_invoiceid.$error },
                        staticStyle: { "text-transform": "uppercase" },
                        attrs: {
                          type: "text",
                          id: "'input_invoiceid",
                          name: "input_invoiceid",
                          placeholder: "E.G.: 545906",
                        },
                        domProps: { value: _vm.input_invoiceid },
                        on: {
                          input: [
                            function ($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.input_invoiceid = $event.target.value
                            },
                            function ($event) {
                              _vm.$v.input_invoiceid.$touch()
                            },
                          ],
                        },
                      }),
                      _vm._v(" "),
                      _vm.$v.input_invoiceid.$dirty &&
                      !_vm.$v.input_invoiceid.required
                        ? _c("p", { staticClass: "errormsg" }, [
                            _vm._v(
                              _vm._s(_vm.errmsg_required[_vm.getCurrentLocale])
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.$v.input_invoiceid.$dirty &&
                      !_vm.$v.input_invoiceid.minLength
                        ? _c("p", { staticClass: "errormsg" }, [
                            _vm._v(
                              _vm._s(
                                _vm.errmsg_min_bookingno[_vm.getCurrentLocale]
                              )
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.$v.input_invoiceid.$dirty &&
                      !_vm.$v.input_invoiceid.maxLength
                        ? _c("p", { staticClass: "errormsg" }, [
                            _vm._v(
                              _vm._s(
                                _vm.errmsg_max_bookingno[_vm.getCurrentLocale]
                              )
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.$v.input_invoiceid.$dirty &&
                      !_vm.$v.input_invoiceid.lettersandnumbers
                        ? _c("p", { staticClass: "errormsg" }, [
                            _vm._v(
                              _vm._s(
                                _vm.errmsg_lettersandnumbers[
                                  _vm.getCurrentLocale
                                ]
                              )
                            ),
                          ])
                        : _vm._e(),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("hr"),
                  _vm._v(" "),
                  !_vm.checkValidity()
                    ? _c(
                        "a",
                        {
                          staticClass:
                            "button btn-large uppercase full-width silver",
                        },
                        [_vm._v(_vm._s(_vm.rebookflight[_vm.getCurrentLocale]))]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.checkValidity()
                    ? _c(
                        "button",
                        {
                          staticClass:
                            "btn-large icon-check-rebooking uppercase full-width icon-check3",
                          style: { background: "#dd3b5f" },
                          attrs: { type: "submit" },
                        },
                        [_vm._v(_vm._s(_vm.rebookflight[_vm.getCurrentLocale]))]
                      )
                    : _vm._e(),
                ]
              ),
            ]),
          ]
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }